import moment from "moment-timezone";
import { sortArrayByProperty } from "../utils/utils";

const initialState = {
  agents: [],
  supervisors: [],
  serviceList: [],
  serviceListByClient: [],
  agentsLoadComplete: false,
  agentsOnCallList: [],
  agentPermissions: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_AGENTS":
      return {
        ...state,
        agents: action.payload,
      };
    case "SET_SUPERVISORS":
      return {
        ...state,
        supervisors: action.payload.map((item) => ({
          ...item,
          isSupervisor: true,
        })),
      };
    case "SET_AGENTPERMISSIONS":
      return {
        ...state,
        agentPermissions: action.payload,
      };
    case "SET_ALL_AGENTS":
      return {
        ...state,
        agents: action.payload,
        agentsLoadComplete: true,
      };
    case "UPDATE_AGENTS_ON_CALL_STATUS":
      return {
        ...state,
        agentsOnCallList: action.payload,
      };
    case "UPDATE_AGENTS_CALL_AVAILABILITY":
      return {
        ...state,
        agents: state.agents.map((item) =>
          item.id == action.payload.data.user_id
            ? {
                ...item,
                availability: action.payload.data.user_status,
                unavailableTime: action.payload.data.date,
                reason: action.payload.data.reason,
                online: action.payload.data.user_online,
                availability_detail: action.payload.data.services_status,
              }
            : item
        ),
        supervisors: state.supervisors.map((item) =>
          item.id == action.payload.data.user_id
            ? {
                ...item,
                availability: action.payload.data.user_status,
                unavailableTime: action.payload.data.date,
                reason: action.payload.data.reason,
                online: action.payload.data.user_online,
                availability_detail: action.payload.data.services_status,
              }
            : item
        ),
      };
    // case "UPDATE_AGENTS_CALL_AVAILABILITY":
    //     return {
    //       ...state,
    //       agents: state.agents.map(item => (item.id == action.payload.data.user_id ?
    //         {
    //            ...item,
    //            availability: action.payload.data.user_status
    //         }
    //         : item))
    //     }
    case "AGENT_ONCALL":
      return {
        ...state,
        agents: state.agents.map((item) =>
          item.extension == action.payload.data.extension
            ? {
                ...item,
                call_id: action.payload.data.id,
                busy: true,
                from: action.payload.data.from,
                to: action.payload.data.to,
                type: action.payload.data.type,
                startTime: action.payload.data.startTime || moment().unix(),
                didAnswer: action.payload.data.didAnswer || false,
                service_name: action.payload.data.service_name,
                service_id: action.payload.data.service_id,
              }
            : item
        ),
        supervisors: state.supervisors.map((item) =>
          item.extension == action.payload.data.extension
            ? {
                ...item,
                call_id: action.payload.data.id,
                busy: true,
                from: action.payload.data.from,
                to: action.payload.data.to,
                type: action.payload.data.type,
                startTime: action.payload.data.startTime || moment().unix(),
                didAnswer: action.payload.data.didAnswer || false,
                service_name: action.payload.data.service_name,
                service_id: action.payload.data.service_id,
              }
            : item
        ),
      };
    case "AGENT_ONCALL_ANSWERED":
      return {
        ...state,
        agents: state.agents.map((item) =>
          item.extension == action.payload.data.extension
            ? {
                ...item,
                call_id: action.payload.data.id,
                busy: true,
                from: action.payload.data.from,
                to: action.payload.data.to,
                type: action.payload.data.type,
                startTime: action.payload.data.startTime || moment().unix(),
                didAnswer: true,
                service_name: action.payload.data.service_name || "",
                service_id: action.payload.data.service_id,
              }
            : item
        ),
        supervisors: state.supervisors.map((item) =>
          item.extension == action.payload.data.extension
            ? {
                ...item,
                call_id: action.payload.data.id,
                busy: true,
                from: action.payload.data.from,
                to: action.payload.data.to,
                type: action.payload.data.type,
                startTime: action.payload.data.startTime || moment().unix(),
                didAnswer: true,
                service_name: action.payload.data.service_name || "",
                service_id: action.payload.data.service_id,
              }
            : item
        ),
      };
    case "QUEUE_CALL_CONNECT":
      return {
        ...state,
        agents: state.agents.map((item) =>
          item.call_id == action.payload.linkedid
            ? {
                ...item,
                service_name: action.payload.service.name,
              }
            : item
        ),
        supervisors: state.supervisors.map((item) =>
          item.call_id == action.payload.linkedid
            ? {
                ...item,
                service_name: action.payload.service.name,
              }
            : item
        ),
      };
    case "AGENT_CALL_TERMINATED":
      const currentTime = moment().unix();
      return {
        ...state,
        agents: state.agents.map((item) =>
          item.extension == action.payload.data.data.extension
            ? {
                ...item,
                busy: false,
                unavailableTime:
                  action.payload.resetTimer === "1"
                    ? currentTime
                    : item.unavailableTime,
                availability_detail:
                  action.payload.resetTimer === "1"
                    ? item.availability_detail.map((detail) => {
                        return {
                          ...detail,
                          status_begin_timestamp: currentTime,
                        };
                      })
                    : item.availability_detail,
              }
            : item
        ),
        supervisors: state.supervisors.map((item) =>
          item.extension == action.payload.data.data.extension
            ? {
                ...item,
                busy: false,
                unavailableTime:
                  action.payload.resetTimer === "1"
                    ? moment().unix()
                    : item.unavailableTime,
                availability_detail:
                  action.payload.resetTimer === "1"
                    ? item.availability_detail.map((detail) => {
                        if (
                          parseInt(detail.service_id) ===
                          parseInt(action.payload.data.data.service_id)
                        ) {
                          return {
                            ...detail,
                            status_begin_timestamp: moment().unix(),
                          };
                        } else {
                          return detail;
                        }
                      })
                    : item.availability_detail,
              }
            : item
        ),
      };
    case "SET_ALL_SERVICES_LIST":
      return {
        ...state,
        serviceList: action.payload,
      };
    case "SET_SERVICES_LIST_BY_CLIENT":
      return {
        ...state,
        serviceListByClient: sortArrayByProperty(action.payload || [], "name"),
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/agentsAndSupervisors.js